<template>
  <VPopup
    ref="priorityPopupRef"
    :target="target"
    visible
    position="right"
    class="payment-request-priority-popup"
    show-pointer
    padding="10px"
  >
    <VSelectV2
      ref="priorityInput"
      v-model="paymentRequest.priorityType"
      label="Приоритет"
      layout="vertical"
      :data="priorityTypeSource"
      option-label="fullName"
      @update:modelValue="savePriority"
    />
  </VPopup>
</template>

<script lang="ts">
import PaymentRequest from "@/domains/PaymentRequests/PaymentRequest";
import PaymentRequestsService from "@/domains/PaymentRequests/PaymentRequestsService";

export default defineComponent({
  name: "PaymentRequestChangePriorityPopup",

  props: {
    paymentRequest: {
      type: PaymentRequest,
      required: true,
    },
    target: {
      type:    HTMLElement,
      default: null,
    },
  },

  data() {
    return {
      priorityTypeSource: this.$core.loader.select(this.$core.dictionaries.paymentPriorityTypes.toArray()).preloadOnFocus(),
    }
  },

  computed: {
    priorityTypes() {
      return this.$core.dictionaries.paymentPriorityTypes;
    },
  },

  mounted(): any {
    this.$refs.priorityInput?.focus();
  },

  methods: {
    async savePriority() {
      if (
        await PaymentRequestsService.updatePriority(
          this.paymentRequest.id,
          this.paymentRequest.priorityType
        )
      ) {
        this.closePopup();
      }
    },

    closePopup() {
      this.$core.dialogs.PaymentRequestChangePriorityPopup.hide()
    }
  }
})
</script>
